import { Pipe, PipeTransform } from '@angular/core';

import { ProjectItem } from 'app/modules/project/services/project-detail.service';
import { ItemLabelWrapper } from 'app/providers/storage-api/object-label.service';

@Pipe({
  name: 'mapProjectItemToLabel',
  standalone: true,
})
export class MapProjectItemToLabelPipe implements PipeTransform {
  transform(item: ProjectItem): ItemLabelWrapper {
    return {
      type: item.type,
      subType: item.displayData.isDriverAnalysis ? 'kda' : undefined,
      id: item.id,
      labels: item.labels,
    };
  }
}
